import React from 'react'
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import { sportLevels } from '../constants/sportLevels'
import { formatPlayingLevel, playingRangeLabel } from '../utils/playingLevels'

export function PlayingLevel({ value, sport }) {
  const { t, locale } = useOptionalPrivanaI18n()
  const level = formatPlayingLevel(value, sport, locale)
  return <small className="mp-playing-level">{level == null ? t('portalPresentation.member_level_not_provided') : `${t(`portalPresentation.${sport === 'golf' ? 'member_handicap_metric' : 'member_level_metric'}`)} ${level}`}</small>
}
export function PlayingRangeBadge({ min, max, sport, visible = true }) {
  const { t, locale } = useOptionalPrivanaI18n()
  if (!visible) return null
  return <span className="mp-chip subtle">{playingRangeLabel({ min, max, sport, locale, t })}</span>
}
export function RacquetRangeControl({ sport, min, max, onMinChange, onMaxChange }) {
  const { t } = useOptionalPrivanaI18n()
  const scale = sportLevels.find(level => level.key === sport && level.key !== 'golf')
  if (!scale) return null
  return <fieldset className="mp-open-play-configuration"><legend>{t('portalPresentation.member_level_preferences')}</legend><p className="mp-text-muted">{t('portalPresentation.member_level_preferences_help')}</p><div className="mp-inline-fields">
    <label>{t('portalPresentation.member_minimum_level')}<input type="number" min={scale.min} max={scale.max} step={scale.step} value={min} onChange={e => onMinChange(e.target.value)} /></label>
    <label>{t('portalPresentation.member_maximum_level')}<input type="number" min={scale.min} max={scale.max} step={scale.step} value={max} onChange={e => onMaxChange(e.target.value)} /></label>
  </div></fieldset>
}
